import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import cmcAssetCache from './CmcAssetCache';
import cmcAssetFetcher from './CmcAssetFetcher';
import { events } from '@/services/wss/SystemEvents';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';

class CmcAssetEngine extends WssEventHandlerBase {
    _name = 'CmcAssetEngine';

    bootup() {
        try {
            super.bootup();
            this.clear();

            this._unsub = this._wsNotifier.subscribe(events.OnCmcAssetsUpdated, this.onUpdatesReceived);
        } catch (error) {
            this.logError('bootup', error.message);
        }
    }

    /**
     * cleanup removes event handlers
     */
    clear() {
        super.clear();

        if (this._unsub) this._unsub();
    }

    /**
     * SignalR handler — called from PageContentSRHandlers on new pushed usage items.
     *
     * @param {object} data - CmcUsageItemDto containing usages for month and day
     */
    onUpdatesReceived = (data) => {
        try {
            this.logDebug('onUpdatesReceived', 'asset updates received');

            cmcAssetCache.addOrUpdate(data);
            this._notify();
        } catch (error) {
            this.logError('onUsageReceived', error.message);
        }
    };

    fetch = async () => {
        try {
            const rawItems = await cmcAssetFetcher.fetch();
            if (!rawItems.length) return;

            this.logDebug('fetch', 'assets fetched');

            cmcAssetCache.addOrUpdate(rawItems);
            this._notify();
        } catch (error) {
            this.logError('fetch', error.message);
        }
    };

    _notify = () => {
        ComponentNotifier.notify(this._name, 'dataChanged', { items: cmcAssetCache.getAll() });
    };
}

const cmcUsageEngine = new CmcAssetEngine();
export default cmcUsageEngine;
